module.exports = __webpack_public_path__ + "img/Bill4Time.772d98c6.svg";